import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttendanceComponent } from './attendance.component';
import { AttendanceRoutingModule } from './attendance-routing.module';
import { AdminSharedModule } from '../shared/admin-shared.module';
import { NewTimeRangePicker } from './new-time-range-picker/new-time-range-picker.component';
import { AttendanceExportComponent } from './attendance-export/attendance-export.component';

@NgModule({
	declarations: [AttendanceComponent, NewTimeRangePicker, AttendanceExportComponent],
	imports: [CommonModule, AttendanceRoutingModule, AdminSharedModule],
	exports: [AttendanceComponent],
})
export class AttendanceModule {}
